// Topibro Technologies SEO & Helmet Configuration

export const indexViewHelmet = {
  title:
    'Topibro Technologies — Software Engineering, AI Solutions & Tech Delivery',
  metaDescription1:
    'Topibro Technologies helps startups and global companies design, build, operate, and scale web apps, mobile apps, cloud backends, and custom AI solutions from Lagos, Nigeria.',
  metaDescription2: '',
  metaKeyWords:
    'topibro technologies, software engineering nigeria, ai solutions africa, web development company lagos, mobile app development africa, custom ai integration, product engineering africa, remote engineering teams lagos',
  ogp: {
    title:
      'Topibro Technologies — Software Engineering, AI Solutions & Tech Delivery',
    url: 'https://topibrotech.com',
    description:
      'Topibro Technologies helps startups and global companies design, build, operate, and scale web apps, mobile apps, cloud backends, and custom AI solutions from Lagos, Nigeria.',
    type: 'website',
    image:
      'https://firebasestorage.googleapis.com/v0/b/topibro-tech.appspot.com/o/minified-images%2Fweb-development-training-page-topibro.png?alt=media&token=3afecaf7-1252-41f2-8d5f-1df58c03e7dc',
    locale: 'en_US',
    site_name: 'Topibro Technologies',
  },
  twitterCards: {
    card: 'summary_large_image',
    site: '@TopibroTech',
    title: 'Topibro Technologies — Software Engineering & AI Solutions',
    description:
      'Topibro Technologies helps startups and global companies design, build, operate, and scale web apps, mobile apps, cloud backends, and custom AI solutions from Lagos, Nigeria.',
    image:
      'https://firebasestorage.googleapis.com/v0/b/topibro-tech.appspot.com/o/minified-images%2Fweb-development-training-page-topibro.png?alt=media&token=3afecaf7-1252-41f2-8d5f-1df58c03e7dc',
  },
};

export const webDevViewHelmet = {
  title: 'Web Application Engineering | Topibro Technologies',
  metaDescription1:
    'Scalable, secure SaaS platforms, enterprise dashboards, custom AI integrations, and web applications engineered with React, Node.js, and cloud microservices.',
  metaDescription2: '',
  metaKeyWords:
    'web development company lagos, React software company nigeria, saas platform engineering africa, enterprise web applications lagos, custom web engineering africa',
  ogp: {
    title: 'Web Application Engineering | Topibro Technologies',
    url: 'https://topibrotech.com/web-development',
    description:
      'Scalable, secure SaaS platforms, enterprise dashboards, custom AI integrations, and web applications engineered with React, Node.js, and cloud microservices.',
    type: 'website',
    image:
      'https://firebasestorage.googleapis.com/v0/b/topibro-tech.appspot.com/o/minified-images%2Fweb-development-training-page-topibro.png?alt=media&token=3afecaf7-1252-41f2-8d5f-1df58c03e7dc',
    locale: 'en_US',
    site_name: 'Topibro Technologies',
  },
  twitterCards: {
    card: 'summary_large_image',
    site: '@TopibroTech',
    title: 'Web Application Engineering | Topibro Technologies',
    description:
      'Scalable, secure SaaS platforms, enterprise dashboards, custom AI integrations, and web applications engineered with React, Node.js, and cloud microservices.',
    image:
      'https://firebasestorage.googleapis.com/v0/b/topibro-tech.appspot.com/o/minified-images%2Fweb-development-training-page-topibro.png?alt=media&token=3afecaf7-1252-41f2-8d5f-1df58c03e7dc',
  },
};

export const mobileAppDevViewHelmet = {
  title: 'Mobile App Development (iOS & Android) | Topibro Technologies',
  metaDescription1:
    'Custom mobile applications for iOS and Android built for high performance, payment gateway integrations, offline capabilities, and African market scale.',
  metaDescription2: '',
  metaKeyWords:
    'mobile app development lagos, react native app developers nigeria, android app engineering africa, ios development team lagos, fintech mobile apps nigeria',
  ogp: {
    title: 'Mobile App Development (iOS & Android) | Topibro Technologies',
    url: 'https://topibrotech.com/mobile-app-development',
    description:
      'Custom mobile applications for iOS and Android built for high performance, payment gateway integrations, offline capabilities, and African market scale.',
    type: 'website',
    image:
      'https://firebasestorage.googleapis.com/v0/b/topibro-tech.appspot.com/o/minified-images%2Fmobile-app-development-training-page-topibro.png?alt=media&token=98a28f79-6f4c-494f-a3b3-bec0d291626a',
    locale: 'en_US',
    site_name: 'Topibro Technologies',
  },
  twitterCards: {
    card: 'summary_large_image',
    site: '@TopibroTech',
    title: 'Mobile App Development (iOS & Android) | Topibro Technologies',
    description:
      'Custom mobile applications for iOS and Android built for high performance, payment gateway integrations, offline capabilities, and African market scale.',
    image:
      'https://firebasestorage.googleapis.com/v0/b/topibro-tech.appspot.com/o/minified-images%2Fmobile-app-development-training-page-topibro.png?alt=media&token=98a28f79-6f4c-494f-a3b3-bec0d291626a',
  },
};

export const webDesignViewHelmet = {
  title: 'UI/UX & Product Design Services | Topibro Technologies',
  metaDescription1:
    'User-centered product discovery, UI/UX design, interactive prototypes, design systems, and implementation-ready experiences for web and mobile products.',
  metaDescription2: '',
  metaKeyWords:
    'product design agency nigeria, ui ux design lagos, web design services africa, prototype design software lagos, design systems engineering',
  ogp: {
    title: 'UI/UX & Product Design Services | Topibro Technologies',
    url: 'https://topibrotech.com/web-design',
    description:
      'User-centered product discovery, UI/UX design, interactive prototypes, design systems, and implementation-ready experiences for web and mobile products.',
    type: 'website',
    image:
      'https://firebasestorage.googleapis.com/v0/b/topibro-tech.appspot.com/o/minified-images%2Fwed-design-training-page-topibro.png?alt=media&token=91406ade-5485-44ba-97d6-c3fac7b914a7',
    locale: 'en_US',
    site_name: 'Topibro Technologies',
  },
  twitterCards: {
    card: 'summary_large_image',
    site: '@TopibroTech',
    title: 'UI/UX & Product Design Services | Topibro Technologies',
    description:
      'User-centered product discovery, UI/UX design, interactive prototypes, design systems, and implementation-ready experiences for web and mobile products.',
    image:
      'https://firebasestorage.googleapis.com/v0/b/topibro-tech.appspot.com/o/minified-images%2Fwed-design-training-page-topibro.png?alt=media&token=91406ade-5485-44ba-97d6-c3fac7b914a7',
  },
};

export const coworkingViewHelmet = {
  title: 'Topibro Hub — Coworking Space & Tech Offices in Lagos',
  metaDescription1:
    'Fully-equipped coworking spaces, private offices, high-speed fiber internet, meeting rooms, and tech community hub in Ijegun, Lagos, Nigeria.',
  metaDescription2: '',
  metaKeyWords:
    'coworking space ijegun lagos, tech hub lagos nigeria, shared workspace lagos, virtual office nigeria, developer hub lagos',
  ogp: {
    title: 'Topibro Hub — Coworking Space & Tech Offices in Lagos',
    url: 'https://topibrotech.com/coworkingspace',
    description:
      'Fully-equipped coworking spaces, private offices, high-speed fiber internet, meeting rooms, and tech community hub in Ijegun, Lagos, Nigeria.',
    type: 'website',
    image:
      'https://firebasestorage.googleapis.com/v0/b/topibro-tech.appspot.com/o/%20coworking%20space%20-%20topibro.jpeg?alt=media&token=461e71b0-0455-4b71-b32d-5e80fe22dc46',
    locale: 'en_US',
    site_name: 'Topibro Technologies',
  },
  twitterCards: {
    card: 'summary_large_image',
    site: '@TopibroTech',
    title: 'Topibro Hub — Coworking Space & Tech Offices in Lagos',
    description:
      'Fully-equipped coworking spaces, private offices, high-speed fiber internet, meeting rooms, and tech community hub in Ijegun, Lagos, Nigeria.',
    image:
      'https://firebasestorage.googleapis.com/v0/b/topibro-tech.appspot.com/o/%20coworking%20space%20-%20topibro.jpeg?alt=media&token=461e71b0-0455-4b71-b32d-5e80fe22dc46',
  },
};

export const trainingHelmet = {
  title: 'Topibro Academy — Practical Tech & Software Engineering Training',
  metaDescription1:
    'Hands-on technology training in software engineering, web development, mobile development, UI/UX, and cloud skills with direct mentorship in Lagos.',
  metaDescription2: '',
  metaKeyWords:
    'software engineering academy lagos, tech training school nigeria, coding bootcamp lagos, learn web development nigeria, topibro academy',
  ogp: {
    title: 'Topibro Academy — Practical Tech & Software Engineering Training',
    url: 'https://topibrotech.com/training',
    description:
      'Hands-on technology training in software engineering, web development, mobile development, UI/UX, and cloud skills with direct mentorship in Lagos.',
    type: 'website',
    image:
      'https://firebasestorage.googleapis.com/v0/b/topibro-tech.appspot.com/o/minified-images%2Ftraining_twitter.png?alt=media&token=b0b37396-2a9d-4805-a0df-eafdeba8ccad',
    locale: 'en_US',
    site_name: 'Topibro Technologies',
  },
  twitterCards: {
    card: 'summary_large_image',
    site: '@TopibroTech',
    title: 'Topibro Academy — Practical Tech & Software Engineering Training',
    description:
      'Hands-on technology training in software engineering, web development, mobile development, UI/UX, and cloud skills with direct mentorship in Lagos.',
    image:
      'https://firebasestorage.googleapis.com/v0/b/topibro-tech.appspot.com/o/minified-images%2Ftraining_twitter.png?alt=media&token=b0b37396-2a9d-4805-a0df-eafdeba8ccad',
  },
};
